import styles from './ManualUpload.module.css';
import { TOfferDataRequirement } from '../../../../../types';
import DocumentRequirement from '../../../DocumentRequirement/DocumentRequirement';

type TProps = {
  title: string;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
const ManualUploadUK = ({ status, isSubmitted }: TProps) => {
  return (
    <DocumentRequirement
      className={styles.documentRequirement}
      documentType="bank statement"
      isSubmitted={isSubmitted}
      status={status}
    >
      <ul>
        <li data-testid="manual-dl-instructons">
          You can download these from your online banking (
          <a
            href="https://static.iwoca.com/pdf/iwoca_bank_statement_pdf_download_guide.pdf"
            target="_blank"
            rel="noreferrer"
          >
            See instructions
          </a>
          )
        </li>
        <li data-testid="manual-file-size">
          Files must be PDF or JPG, JPEG, PNG and no more than 2GB.
        </li>
        <li data-testid="manual-business-revenue">
          These should be for the account(s) where the majority of your business
          revenue is generated.
        </li>
        <li data-testid="manual-statement-info">
          Please ensure the statements display the business name, sort code,
          account number and the account balance.
        </li>
      </ul>
    </DocumentRequirement>
  );
};

export default ManualUploadUK;
